import { useIsReviewMode } from '../ViewContext';
import { FieldFragment } from '../brief.generated';
import type { Display, DisplayStatus } from '@99designs/graph-utils/types';

const NON_HIDDEN_DISPLAY_STATUSES: DisplayStatus[] = [
    'DISPLAY_STATUS_VISIBLE',
    'DISPLAY_STATUS_READ_ONLY',
    'DISPLAY_STATUS_HIDDEN_GROUP',
];

export function isDisplayReview(
    display: Display | null | undefined,
    isReview: boolean,
    isAfterAddToCart: boolean
): boolean {
    if (!display || !isReview) {
        return false;
    }

    const relevantDisplay = isAfterAddToCart ? display.cart : display.review;

    return relevantDisplay === 'DISPLAY_STATUS_READ_ONLY';
}

export function getDisplayStatus(
    display: Display | null | undefined,
    isReview: boolean,
    isAfterAddToCart: boolean
): DisplayStatus {
    if (!display) {
        return 'DISPLAY_STATUS_VISIBLE';
    }

    let relevantDisplay = display.step;
    if (isAfterAddToCart) {
        relevantDisplay = display.cart;
    } else if (isReview) {
        relevantDisplay = display.review;
    }

    return relevantDisplay;
}

export function getIsFieldHidden(
    field: FieldFragment,
    isReview?: boolean,
    isAfterAddToCart?: boolean,
    isOverrideDisplayConfig = false
): boolean {
    if (
        isReview &&
        field.__typename === 'ClientConfiguredField' &&
        field.id === 'physicalProduct' &&
        !field.questionId.startsWith('design-physical-product')
    ) {
        // TODO: Update schemas to add display.review to hidden for physicalProduct then remove this check.

        return true;
    }

    if (!field.display) {
        return false;
    }

    if (isOverrideDisplayConfig) {
        // Default to not hidden.

        return false;
    }

    const displayStatus = getDisplayStatus(
        field.display,
        isReview || false,
        isAfterAddToCart || false
    );

    if (!displayStatus) {
        // This fixes a bug where the step or review has no value, showing a group with no title or fields.

        return false;
    }

    return !NON_HIDDEN_DISPLAY_STATUSES.includes(displayStatus);
}

export function useIsFieldHidden(
    field: FieldFragment,
    isAfterAddToCart = false,
    isOverrideDisplayConfig = false
): boolean {
    const isReviewMode = useIsReviewMode();
    return getIsFieldHidden(field, isReviewMode, isAfterAddToCart, isOverrideDisplayConfig);
}
